import { render, staticRenderFns } from "./detailStaffConnect.vue?vue&type=template&id=d8999114&scoped=true&"
import script from "./detailStaffConnect.vue?vue&type=script&lang=js&"
export * from "./detailStaffConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8999114",
  null
  
)

export default component.exports